import { render } from "./CustomersReporting.vue?vue&type=template&id=1f0c0c04&scoped=true"
import script from "./CustomersReporting.vue?vue&type=script&lang=js"
export * from "./CustomersReporting.vue?vue&type=script&lang=js"

import "./CustomersReporting.vue?vue&type=style&index=0&id=1f0c0c04&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f0c0c04"]])

export default __exports__